import { Link } from 'react-router-dom';
import { latestUpdates, popularRankings } from '@/mocks/comics';

export default function SideContent() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <div className="mb-2">
              <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest">
                实时追踪
              </span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-8">
              最新更新
            </h2>
            <div className="flex flex-col gap-3">
              {latestUpdates.map((update) => (
                <Link
                  key={update.id}
                  to={`/comic/${update.slug}`}
                  className="flex items-center justify-between p-4 rounded-xl bg-background-100/60 hover:bg-background-100 transition-colors duration-200 cursor-pointer group"
                >
                  <div className="flex items-center gap-4 min-w-0">
                    <div className="w-2 h-2 rounded-full bg-primary-500 flex-shrink-0"></div>
                    <div className="min-w-0">
                      <span className="text-sm font-medium text-foreground-200 group-hover:text-primary-300 transition-colors duration-200 block truncate">
                        {update.title}
                      </span>
                      <span className="text-xs text-foreground-500">{update.chapter}</span>
                    </div>
                  </div>
                  <span className="text-xs text-foreground-600 flex-shrink-0 ml-4">{update.time}</span>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="mb-2">
              <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest">
                数据排行
              </span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-8">
              热门排行
            </h2>
            <div className="flex flex-col gap-2">
              {popularRankings.map((item) => (
                <Link
                  key={item.rank}
                  to={`/comic/${item.slug}`}
                  className="flex items-center gap-4 p-3 rounded-xl hover:bg-background-100/60 transition-colors duration-200 cursor-pointer group"
                >
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                      item.rank <= 3
                        ? 'bg-primary-500 text-foreground-50'
                        : 'bg-background-200/60 text-foreground-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <span className="text-sm font-medium text-foreground-200 group-hover:text-primary-300 transition-colors duration-200 block truncate">
                      {item.title}
                    </span>
                    <span className="text-xs text-foreground-600">{item.category}</span>
                  </div>
                  <span className="text-xs text-foreground-500 flex-shrink-0">
                    <i className="ri-eye-line mr-1"></i>{item.views}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}